import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";

import AutomationAttributeTiptap from "./AutomationAttributeTiptap.vue";

export default Node.create({
    name: "automation-attribute-editor",
    inline: true,
    group: "inline",

    addAttributes() {
        return {
            name: {
                default: "name",
            },
            "data-id": {
                default: "default",
            },
            allowedAttributes: {
                default: [],
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: "automation-attribute-editor",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ["automation-attribute-editor", mergeAttributes(HTMLAttributes)];
    },

    addNodeView() {
        return VueNodeViewRenderer(AutomationAttributeTiptap);
    },
});
